import { v4 as uuidv4 } from 'uuid';

export const useSearchSession = () => {
  // Init session on reload of application
  return useState('session-id', () => shallowRef(uuidv4()));
};
